import React, { useState, useEffect } from 'react';
import GeneralInfoView from './view';

const GeneralInfoContainer = ({
  // Target specification
  target, // { type: 'workArea' | 'meetingRoom', slug: 'work-area-123' }
  formData, // { name: '', description: '', capacity: 0, status: 'AC' }
  onFormChange, // (newFormData) => void
  onSave, // (formData) => Promise<void> - NEW: Direct save handler
  onCancel, // () => void - NEW: Cancel handler
  canActivate = true, // whether status can be set to 'AC'
  hasChanges = false, // NEW: Whether there are unsaved changes
  isSaving = false // NEW: Whether save operation is in progress
}) => {
  const [errors, setErrors] = useState({});

  // Determine if we're in work area mode
  const isWorkAreaMode = target.type === 'workArea';

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    const newFormData = {
      ...formData,
      [name]: value
    };

    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: null
      }));
    }
    
    // Notify parent of changes
    if (onFormChange) {
      onFormChange(newFormData);
    }
  };

  // Basic form validation
  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name?.trim()) {
      newErrors.name = 'Name is required';
    }
    
    if (isWorkAreaMode && formData.capacity < 0) {
      newErrors.capacity = 'Number of hot desks cannot be negative';
    } else if (!isWorkAreaMode && formData.capacity < 1) {
      newErrors.capacity = 'Capacity must be at least 1';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle save button click
  const handleSave = async () => {
    if (!validateForm()) {
      return;
    }

    if (onSave) {
      try {
        await onSave(formData);
        // Clear any validation errors on successful save
        setErrors({});
      } catch (error) {
        console.error('Error saving general info:', error);
        // Don't clear errors on save failure
      }
    }
  };

  // Handle cancel button click
  const handleCancel = () => {
    // Clear any validation errors
    setErrors({});
    
    if (onCancel) {
      onCancel();
    }
  };

  // Get capacity label based on mode
  const getCapacityLabel = () => {
    return isWorkAreaMode ? 'Number of hot desks' : 'Capacity';
  };

  // Get entity label
  const getEntityLabel = () => {
    return isWorkAreaMode ? 'space' : 'meeting room';
  };

  return (
    <GeneralInfoView
      formData={formData}
      errors={errors}
      handleInputChange={handleInputChange}
      validateForm={validateForm}
      getCapacityLabel={getCapacityLabel}
      getEntityLabel={getEntityLabel}
      isWorkAreaMode={isWorkAreaMode}
      canActivate={canActivate}
      // NEW: Save/Cancel functionality
      hasChanges={hasChanges}
      isSaving={isSaving}
      onSave={handleSave}
      onCancel={handleCancel}
      showSaveButton={!!onSave} // Show save button only if onSave handler is provided
    />
  );
};

export default GeneralInfoContainer;